
import './styles/index.scss';
import HomePage from "./pages/HomePage";
import {BrowserRouter, Route, Switch, useHistory, withRouter, Redirect} from "react-router-dom";
import Logs from "./pages/Logs";
import Map from "./pages/Map";
import Login from "./pages/Login";
import ApiProvider, {useApi} from "./provider/ApiProvider";
import CompaniesPage from "./pages/CompaniesPage";
import UsersPage from "./pages/UsersPage";
import ActivityPage from "./pages/ActivityPage";
import ActivitySavePage from "./pages/ActivitySavePage";
import BlogsPage from "./pages/BlogsPage";
import BlogSavePage from "./pages/BlogSavePage";
import InfoPage from "./pages/InfoPage";
import PlatformsPage from "./pages/PlatformsPage";
import CustomersPage from "./pages/CustomersPage";
import AppConfigPage from "./pages/AppConfigPage";
import Announcements from "./pages/Announcements";
import { Spin, Space } from 'antd';
import { ConfigProvider } from 'antd';
import moment from "moment";
import 'moment/locale/tr';
import locale from 'antd/lib/locale-provider/tr_TR';
import NewsPage from "./pages/NewsPage";
import NewsSavePage from "./pages/NewsSavePage";
import RolesPage from "./pages/RolesPage";
import Notifications from "./pages/Notifications";
import Supports from "./pages/Supports";
import UserRestartPage from "./pages/UserRestartPage";
import LoginInformations from "./pages/LoginInformations";
import FootTicketPage from "./pages/FoodTicketPage";
import FoodListPage from "./pages/FoodList.Page";
import TargetLocationPage from "./pages/TargetLocationPage";
import TargetLocationSavePage from "./pages/TargetLocationSavePage";
import TargetLocationViewPage from "./pages/TargetLocationViewPage";
import TargetLocationQrPrintPage from "./pages/TargetLocationQrPrintPage";


function App() {

    return (
      <ConfigProvider locale={locale}>
          <ApiProvider>
              <RouterCustom/>
          </ApiProvider>
      </ConfigProvider>


  );
}

function RouterCustom(){

    const {user} = useApi();


    return (
        <div>

            {user ? (
                    <BrowserRouter>
                        <Switch>
                            <Route exact path="/" component={HomePage} />
                            <Route exact path="/logs" component={Logs} />
                            <Route exact path="/map" component={Map} />

                            <Route exact path="/platforms" component={PlatformsPage} />
                            <Route exact path="/customers" component={CustomersPage} />
                            <Route exact path="/companies" component={CompaniesPage} />


                            <Route exact path="/activity" component={ActivityPage} />
                            <Route exact path="/activity/add" component={ActivitySavePage} />
                            <Route exact path="/activity/add/:id" component={ActivitySavePage} />

                            <Route exact path="/food-ticket" component={FootTicketPage} />
                            <Route exact path="/food-list" component={FoodListPage} />

                            <Route exact path="/news" component={NewsPage} />
                            <Route exact path="/news/add" component={NewsSavePage} />
                            <Route exact path="/news/add/:id" component={NewsSavePage} />

                            <Route exact path="/blogs" component={BlogsPage} />
                            <Route exact path="/blog/add" component={BlogSavePage} />
                            <Route exact path="/blog/add/:id" component={BlogSavePage} />
                            <Route exact path="/notifications" component={Notifications} />

                            <Route exact path="/roles" component={RolesPage} />
                            <Route exact path="/users" component={UsersPage} />
                            <Route exact path="/login-informations" component={LoginInformations} />

                            <Route exact path="/info" component={InfoPage} />
                            <Route exact path="/login" component={Login} />

                            <Route exact path="/announcements" component={Announcements} />

                            <Route exact path="/app-config" component={AppConfigPage} />
                            <Route exact path="/user-restart" component={UserRestartPage} />

                            <Route exact path="/supports" component={Supports} />
                            
                            {/* Target Location Routes */}
                            <Route exact path="/target-locations" component={TargetLocationPage} />
                            <Route exact path="/target-locations/add" component={TargetLocationSavePage} />
                            <Route exact path="/target-locations/edit/:id" component={TargetLocationSavePage} />
                            <Route exact path="/target-locations/view/:id" component={TargetLocationViewPage} />
                            <Route exact path="/target-locations/qr-print/:id" component={TargetLocationQrPrintPage} />
                        </Switch>
                    </BrowserRouter>
            ) : (
                <Login/>
            )}
        </div>
    )
}


export default App;
